import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

/**
 * این کامپوننت برای اکسل است و زمانی رو دکمه این کامپوننت کلیک شود 
 * از تمام جدولی که در نمایش است اکس میگیرد
 */
export default function ExcelExport({ data, filename, headers }) {

    //data = data.map(x=>x.workerOrderSchedules = null);

    // data.forEach(x =>  {
    //     x.workerOrderSchedules = null
    //  });

    return (
        <ExcelFile
            filename={filename}
            element={<button type="button"
                className="btn btn-primary btn-icon-text mr-3 btn-sm">
                اکسل {" "} <i className="mdi mdi-file-excel"></i></button>}

        >
            <ExcelSheet data={data} name={filename}  >
                {data.length > 0 ?
                    headers.map((item, index) => {
                        return <ExcelColumn
                            key={index.toString()}
                            label={headers[index]}
                            value={Object.keys(data[0])[index] === "workerOrderSchedules" ? "" : Object.keys(data[0])[index]} />
                    })
                    : null}
            </ExcelSheet>
        </ExcelFile>
    )
}